/**
 * This (removes if already exists) and inserts the AppLovin tracking pixel into the page everytime it is invoked.
 */
export function appLovinPageView() {
  // Remove existing script if it exists
  const existingScript = document.querySelector(
    'script[src="https://pxl.iqm.com/i/pixel/10191f21-fd73-4485-bc5d-1dcd526128a1"]'
  )
  if (existingScript && existingScript.parentNode) {
    existingScript.parentNode.removeChild(existingScript)
  }

  // Insert new script into the head
  const script = document.createElement('script')
  script.src = 'https://pxl.iqm.com/i/pixel/10191f21-fd73-4485-bc5d-1dcd526128a1'
  script.async = true
  document.head.appendChild(script)
}

/**
 * This (removes if already exists) and inserts the AppLovin add to cart pixel into the page everytime it is invoked.
 */
export function appLovingCartAdd(atcValue: number) {
  const existingScript = document.querySelector(
    'script[src="https://pxl.iqm.com/i/pixel/6512c23d-1cac-490b-8e88-f4e93141e8e7"]'
  )
  if (existingScript && existingScript.parentNode) {
    existingScript.parentNode.removeChild(existingScript)
  }
  const script = document.createElement('script')
  script.src = `https://pxl.iqm.com/i/pixel/6512c23d-1cac-490b-8e88-f4e93141e8e7?cv=${atcValue}`
  script.async = true
  document.head.appendChild(script)
}
